/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Directory_Title_QueryInputs */

const en_directory_title_query = /** @type {(inputs: Directory_Title_QueryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.query}”`)
};

const pl_directory_title_query = /** @type {(inputs: Directory_Title_QueryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`„${i?.query}”`)
};

/**
* | output |
* | --- |
* | "“{query}”" |
*
* @param {Directory_Title_QueryInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_title_query = /** @type {((inputs: Directory_Title_QueryInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Title_QueryInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_title_query(inputs)
	return en_directory_title_query(inputs)
});